// ----------------------------------------------------------------------
// Estado mutable de la caché de catálogo de seguros, aislado en su propio
// módulo por una razón concreta: `insurance-service-calls.js` tiene que poder
// invalidar la caché tras crear/editar/borrar una aseguradora o un plan, y
// `insurance-catalog-cache.js` importa de `insurance-service-calls.js` para
// hacer las peticiones. Si la invalidación viviera allí, el import sería
// circular.
//
// Este módulo no importa nada: puede importarlo cualquiera de los dos.
// ----------------------------------------------------------------------

export const TTL_MS = 30 * 60 * 1000;
export const CLAVE_PROVEEDORES = 'medicore.insurance.providers.v1';

export const estado = {
  /** Promesa memoizada de la lista de aseguradoras (o null). */
  promesaProveedores: null,
  /** providerId -> promesa memoizada de sus planes. */
  promesasPlanesPorProveedor: new Map(),
};

/**
 * Invalida todo el catálogo cacheado (aseguradoras y planes de todos los
 * proveedores). Llamar SIEMPRE tras una mutación del catálogo; si no, la
 * pantalla de administración seguiría enseñando su propia lista
 * desactualizada hasta que venciera el TTL, que es largo a propósito.
 */
export function invalidarCatalogoSeguros() {
  estado.promesaProveedores = null;
  estado.promesasPlanesPorProveedor.clear();
  try {
    sessionStorage.removeItem(CLAVE_PROVEEDORES);
  } catch {
    // Nada que hacer: la caché en memoria ya quedó limpia, que es la que manda.
  }
}
